export default defineNuxtPlugin(() => {
  const { $flushTracking, $tracking } = useNuxtApp()
  const router = useRouter()
  const store = useStore()

  router?.beforeResolve((_: any, __: any, next: any) => {
    $flushTracking?.()
    next()
  })

  router?.afterEach((to: any, from: any) => {
    $tracking.push(
      mapTrackingDataForEvent('content_view', {
        content_name: to.path,
        title: (typeof document !== 'undefined' && document.title) || '',
        page_type: store.value.pageType,
        page_type_id: store.value.pageTypeId,
        click_origin: from?.fullPath,
      }),
    )
  })
})
